export const resolveDesignerVersionToLoad = (designerVersion: string): string => (designerVersion.toLowerCase() === 'latest' ? '2.9.3' : designerVersion);
